<div fxLayout="column" fxLayoutGap="16px" style="margin-bottom: 24px">
  <h2 class="margin-bottom-32">When does this tax apply?</h2>

  <div>
    <div fxFlexFill fxLayout="column">
      <mat-radio-group [(ngModel)]="durationSelected" (ngModelChange)="checkIfOkToProgress()">
        <div fxLayout fxLayoutGap="4px" fxLayoutAlign="start center">
          <mat-radio-button class="selection-box" [value]="false">
            <span fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
              <span fxFlex>On all stays</span>
            </span>
          </mat-radio-button>
        </div>
        <div fxLayout fxLayoutGap="4px" fxLayoutAlign="start center">
          <mat-radio-button class="selection-box" [value]="true">
            <span fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
              <div>On stays of</div>
              <div class="dropdown-select duration" [matMenuTriggerFor]="daysMenu">
                {{ tax.max_number_of_nights }}
              </div>
              <div>days or less</div>
            </span>
          </mat-radio-button>
        </div>

        <div
          *ngIf="hasMaxNumberOfNightsError"
          class="text-raspberry-darker text-xs ml-2"
          fxLayout
          fxLayoutGap="4px"
          fxLayoutAlign="start center">
          The number of days needs to be greater than 0 and less than 365
        </div>
      </mat-radio-group>
    </div>
  </div>
</div>

<mat-menu #daysMenu="matMenu" (click)="$event.preventDefault(); $event.stopPropagation()">
  <div class="flex p-2 gap-2" (click)="$event.preventDefault(); $event.stopPropagation()">
    <mat-form-field class="no-padding short-number-input">
      <input
        autofocus
        matInput
        type="number"
        min="0"
        max="365"
        pattern="^(365|[1-9]?\d(\.\d\d?)?)$"
        [(ngModel)]="tax.max_number_of_nights"
        (ngModelChange)="checkIfOkToProgress()"
        (click)="$event.preventDefault(); $event.stopPropagation()" />
    </mat-form-field>

    <div class="mt-4">days</div>
  </div>
</mat-menu>

<div style="margin-top: 32px" fxLayout fxLayoutGap="24px" fxLayoutAlign="end center">
  <sbnb-button
    data-intercom-target="direct-add-tax-setup-back"
    label="Back"
    type="secondary"
    (click)="back()"></sbnb-button>

  <sbnb-button
    [disabled]="!isOkToProceed"
    data-intercom-target="direct-add-tax-setup-save"
    label="Continue"
    (clicked)="progress()"></sbnb-button>
</div>
